module.exports = __webpack_public_path__ + "media/images/projet_04-6c91cd316f44be9f19a2a5d8028a6f07.jpg";